"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$ = exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$inboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$ = exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$outboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$inboundSchema = void 0;
exports.getAgentListingsInAreaAreasAgentListingsGetSecurityToJSON = getAgentListingsInAreaAreasAgentListingsGetSecurityToJSON;
exports.getAgentListingsInAreaAreasAgentListingsGetSecurityFromJSON = getAgentListingsInAreaAreasAgentListingsGetSecurityFromJSON;
exports.getAgentListingsInAreaAreasAgentListingsGetRequestToJSON = getAgentListingsInAreaAreasAgentListingsGetRequestToJSON;
exports.getAgentListingsInAreaAreasAgentListingsGetRequestFromJSON = getAgentListingsInAreaAreasAgentListingsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentListingsInAreaAreasAgentListingsGetSecurity$;
(function (GetAgentListingsInAreaAreasAgentListingsGetSecurity$) {
    /** @deprecated use `GetAgentListingsInAreaAreasAgentListingsGetSecurity$inboundSchema` instead. */
    GetAgentListingsInAreaAreasAgentListingsGetSecurity$.inboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$inboundSchema;
    /** @deprecated use `GetAgentListingsInAreaAreasAgentListingsGetSecurity$outboundSchema` instead. */
    GetAgentListingsInAreaAreasAgentListingsGetSecurity$.outboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$outboundSchema;
})(GetAgentListingsInAreaAreasAgentListingsGetSecurity$ || (exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$ = GetAgentListingsInAreaAreasAgentListingsGetSecurity$ = {}));
function getAgentListingsInAreaAreasAgentListingsGetSecurityToJSON(getAgentListingsInAreaAreasAgentListingsGetSecurity) {
    return JSON.stringify(exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$outboundSchema.parse(getAgentListingsInAreaAreasAgentListingsGetSecurity));
}
function getAgentListingsInAreaAreasAgentListingsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentListingsInAreaAreasAgentListingsGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetAgentListingsInAreaAreasAgentListingsGetSecurity' from JSON`);
}
/** @internal */
exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$inboundSchema = z.object({
    "filter[listing_type]": shared.ListingType$inboundSchema.optional(),
    outcode: z.string().optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[listing_type]": "filterListingType",
    });
});
/** @internal */
exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema = z.object({
    filterListingType: shared.ListingType$outboundSchema.optional(),
    outcode: z.string().optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterListingType: "filter[listing_type]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentListingsInAreaAreasAgentListingsGetRequest$;
(function (GetAgentListingsInAreaAreasAgentListingsGetRequest$) {
    /** @deprecated use `GetAgentListingsInAreaAreasAgentListingsGetRequest$inboundSchema` instead. */
    GetAgentListingsInAreaAreasAgentListingsGetRequest$.inboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$inboundSchema;
    /** @deprecated use `GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema` instead. */
    GetAgentListingsInAreaAreasAgentListingsGetRequest$.outboundSchema = exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema;
})(GetAgentListingsInAreaAreasAgentListingsGetRequest$ || (exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$ = GetAgentListingsInAreaAreasAgentListingsGetRequest$ = {}));
function getAgentListingsInAreaAreasAgentListingsGetRequestToJSON(getAgentListingsInAreaAreasAgentListingsGetRequest) {
    return JSON.stringify(exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema.parse(getAgentListingsInAreaAreasAgentListingsGetRequest));
}
function getAgentListingsInAreaAreasAgentListingsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentListingsInAreaAreasAgentListingsGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetAgentListingsInAreaAreasAgentListingsGetRequest' from JSON`);
}
//# sourceMappingURL=getagentlistingsinareaareasagentlistingsget.js.map